import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

export default function MasterStatusSelectFilter({ onChange, value }) {
  const cndOptions = [
    { label: 'All Statuses', value: 'all' },
    { label: 'Unallocated', value: 'UNALLOCATED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Allocated', value: 'ALLOCATED' },
    { label: 'Awaiting Pickup', value: 'AWAITING_PICKUP' },
    { label: 'Being Collected', value: 'BEING_COLLECTED' },
    { label: 'Transport to Garage', value: 'TRANSPORT_TO_GARAGE' },
    { label: 'At Garage', value: 'AT_GARAGE' },
    { label: 'Work Complete', value: 'WORK_COMPLETE' },
    { label: 'Paid', value: 'PAID' },
    { label: 'Being Returned', value: 'BEING_RETURNED' },
    { label: 'Closed', value: 'CLOSED' },
    { label: 'Cancelled', value: 'CANCELLED' },
    { label: 'Garage Declined', value: 'GARAGE_DECLINED' },
    { label: 'BOOKING_CHANGE', value: 'BOOKING_CHANGE' },
    { label: 'UNPAID', value: 'UNPAID' },
    { label: 'DISPUTE', value: 'DISPUTE' },
  ];

  const renderOptions = (options) =>
    options.map(({ label, value: optionValue }) => (
      <Select.Option key={optionValue} value={optionValue}>
        {label}
      </Select.Option>
    ));

  return (
    <div className={`filter-container ${value ? 'active' : ''}`}>
      <img src="/assets/icons/filters/tag.svg" alt="Status filter" />
      <Select
        key="masterStatuses"
        style={{ width: '90%' }}
        dropdownMatchSelectWidth={false}
        onChange={onChange}
        value={value || 'all'}
      >
        {renderOptions(cndOptions)}
      </Select>
    </div>
  );
}

MasterStatusSelectFilter.propTypes = {
  onChange: PropTypes.any.isRequired,
  value: PropTypes.string,
};

MasterStatusSelectFilter.defaultProps = {
  value: null,
};
